import { render, staticRenderFns } from "./product-tags.vue?vue&type=template&id=73ebcfd7&scoped=true&"
import script from "./product-tags.vue?vue&type=script&lang=js&"
export * from "./product-tags.vue?vue&type=script&lang=js&"
import style0 from "./product-tags.vue?vue&type=style&index=0&id=73ebcfd7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ebcfd7",
  null
  
)

export default component.exports